module.exports = __webpack_public_path__ + "img/kr-bg-top-left.654c094.png";